export default    
	{
        path:'/strongBase',
        name:'强基综评复试',
        redirect:'/strongBase/main',
        component:()=>import('../views/strongBase/index'),
        meta:{requireAuth:true,roles:['student']},
        children:[
            {
                path:'/strongBase/main',
                name:'强基综评复试',
                component:()=>import('../views/strongBase/main'),
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path:'/strongBase/course',
                name:'我的视频课程',
                component:()=>import('../views/strongBase/course'),
                meta:{requireAuth:true,roles:['student']},
            },

        ]
    }